import React, {useEffect, useState} from 'react';

import Facebook from "./Facebook";
import Twitter from "./Twitter";
import YouTube from "./YouTube";
import Instagram from "./Instagram";
import {useParams} from "react-router-dom";
import { Alert, Tab, Tabs, Divider, styled } from '@mui/material';
import ContentHeader from '../content-header';
import { useNavigate } from 'react-router';


const AntTabs = styled(Tabs)({
    root: {
        borderBottom: '1px solid #e8e8e8',
    },
    indicator: {
        backgroundColor: '#1890ff',
    },
});
  
const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: 'none',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
        color: '#40a9ff',
        opacity: 1,
    },
    '&$selected': {
        color: '#1890ff',
        fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
        color: '#40a9ff',
    },
}));

function SnsAuth(props) {
    const [value, setValue] = React.useState(0);

    const [expiredMessages, setExpiredMessages] = useState([]);

    let { slug } = useParams();
    let navigate = useNavigate();

    console.log(slug)

    useEffect(() => {
        console.log(slug)
        switch(slug){
            case "twitter":
                setValue(0);
                break;
            // case "facebook":
            //     setValue(1);
            //     break;
            case "youtube":
                setValue(1);
                break;
            case "instagram":
                setValue(2);
                break;
            default:
                console.log(slug)
                break;
        }
    }, [slug]);


    const handleChange = (event, newValue) => {
        console.log(newValue)
        setValue(newValue);
        let nextSlug = "";
        switch(newValue){
            case 0:
                nextSlug = "twitter";
                break;
            // case 1:
            //     nextSlug = "facebook"
            //     break;
            case 1:
                nextSlug = "youtube";
                break;
            case 2:
                nextSlug = "instagram";
                break;
        }
        navigate("/snsauth/" + nextSlug)
        setExpiredMessages([]);
    };

    return (
        <div id="Category">
            <ContentHeader title={"SNS連携設定"} breadCrumbItems={[
            {title:"SNS連携設定",icon:"notification",path:""}
            ]}/>
            <br/>
            <br/>
            {expiredMessages.map((msg) => (
                <Alert key={msg} severity="warning" sx={{ mb: 0.5 }}>
                {msg}
                </Alert>
            ))}
            <div id="content_wrapper" style={{position:"relative"}}>
                <div style={{position:'absolute', top:-8}} >
                    <AntTabs value={value} onChange={handleChange} aria-label="ant example">
                        <AntTab label="Twitter" />
                        {/* <AntTab label="Facebook" /> */}
                        <AntTab label="YouTube" />
                        <AntTab label={"Instagram"} />
                    </AntTabs>
                </div>
                <div>
                    {value === 0 && <Twitter {...props}/>}
                    {/* {value === 1 && <Facebook {...props}/>} */}
                    {value === 1 && <YouTube {...props}/>}
                    {value === 2 && <Instagram {...props} onExpiredMessages={setExpiredMessages}/>}
                </div>
            </div>
        </div>
    );
}

export default SnsAuth;